import React from 'react';

const SetupTitle = (props) => {
    return (
        <div style={{ fontWeight: 700, fontSize: props?.small ? 16 : 20 }}>
            {props?.children}
        </div>
    );
}

export default SetupTitle;